import { render } from "./CoachItem.vue?vue&type=template&id=dd0e2092&scoped=true"
import script from "./CoachItem.vue?vue&type=script&lang=js"
export * from "./CoachItem.vue?vue&type=script&lang=js"

import "./CoachItem.vue?vue&type=style&index=0&id=dd0e2092&scoped=true&lang=css"

import exportComponent from "/home/hiba/project03-vue.js-find-a-coach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd0e2092"]])

export default __exports__